
export const testimonials = [
  {
    id: 1,
    name: "Mr.Sham Mapari",
    location: "Lonar, Buldhana, Maharashtra",
    role: "CSP Partner",
    avatar: "SM",
    color: "#85aac7",
    quote: "The best thing about CSP.in is that it is a platform that truly listens to its partners. The suggestions I shared are genuinely considered and efforts are made to incorporate them into the platform.",
    quotehindi: "CSP.in की सबसे अच्छी बात यह है कि यह एक ऐसा प्लेटफ़ॉर्म है जो अपने पार्टनर्स की बात सुनता है। मैंने जो सुझाव दिए, उन्हें प्लेटफ़ॉर्म में शामिल करने की पूरी कोशिश की जाती है।",
    highlight: "",
    rating: 5,
    earnings: "₹42,000/month",
    duration: "0:50",
    videoSrc: "https://youtube.com/shorts/u72jEEI2L5s?feature=share",
  },
  {
    id: 2,
    name: "Mr. Dasharath chankhore",
    location: "Mehekar, Buldhana, Maharashtra",
    role: "CSP Partner",
    avatar: "DC",
    color: "#16b287",
    quote: " CSP.in offers multiple services on a single platform, helping generate good income opportunities.",
    quotehindi: "CSP.in पर आपको एक ही प्लेटफ़ॉर्म पर कई सेवाएँ मिल जाती हैं, जिससे अच्छी आय के अवसर भी बनते हैं।",
    highlight: "Travel & Bill Payments",
    rating: 5,
    earnings: "₹38,000/month",
    duration: "1:26",
    videoSrc: "https://youtube.com/shorts/A7uGTpQoC9o?feature=share",
  },
  {
    id: 4,
    name: "Mr. Santosh Sagare",
    location: "Sillod, Chatrapati Sambhaji Nagar, Maharashtra",
    role: "CSP Partner",
    avatar: "SS",
    color: "#8e44ad",
    quote: "An excellent platform with fast services and a hassle-free experience.",
    quotehindi: "बेहतरीन प्लेटफ़ॉर्म, तेज़ सेवा और बिल्कुल आसान प्रक्रिया—कोई झंझट नहीं।",
    highlight: "GST Filing",
    rating: 5,
    earnings: "₹55,000/month",
    duration: "1:10",
    videoSrc: "https://youtube.com/shorts/SWg-6pmqmug",
  },
  {
    id: 3,
    name: "Ms. Rupali Vaidya",
    location: "Mehekar, Buldhana, Maharashtra",
    role: "CSP Partner",
    avatar: "RV",
    color: "#e67e22",
    quote: "The support from the CSP.in team is excellent. They go the extra mile to resolve our queries and issues.",
    quotehindi: "CSP.in टीम का सपोर्ट बेहतरीन है। वे हमारी समस्याओं और सवालों को हल करने के लिए हमेशा एक कदम आगे बढ़कर मदद करते हैं।",
    highlight: "Insurance & Loans",
    rating: 5,
    earnings: "₹29,000/month",
    duration: "0:51",
    videoSrc: "https://youtube.com/shorts/1dtefd8WO3k?feature=share",
  },
  {
    id: 5,
    name: "Mr. Sandip Bhagat",
    location: "Ahilya Nagar, Maharashtra",
    role: "CSP Partner",
    avatar: "SB",
    color: "#c0392b",
    quote: "CSP.in is very simple to use, and Mr. Sandeep Bhagat himself provides a quick demo to help you understand it.",
    quotehindi: "CSP.in इस्तेमाल करने में बहुत आसान है, और संदीप भगत खुद एक छोटा सा डेमो देकर इसे समझाते हैं।",
    highlight: "Aadhar Pay & Digital Gold",
    rating: 5,
    earnings: "₹48,000/month",
    duration: "1:56",
    videoSrc: "https://youtube.com/shorts/yMc7HKrs0MY?feature=share",
  },
];




export const platformDemoData = [
  {
    id: 1,
    name: "Registration And Login",
    location: "Detailed Registration And Login Process",
    role: "Demo",
    avatar: "SM",
    color: "#85aac7",
    quote:`We guide you through the complete registration and login process so you can get started quickly and easily.`,
    highlight: "",
    rating: 0,
    earnings: "₹42,000/month",
    duration: "3:50",
    videoSrc: "https://youtu.be/quJGo-o_UJI",
  },
  {
    id: 2,
    name: "Services Overview",
    location: "AEPS,DMT,Recharge & BBPS and More",
    role: "Services",
    avatar: "DC",
    color: "#16b287",
    quote: "In this video, we provide a complete overview of all services available on the CSP.in platform to help you understand how you can serve customers efficiently and grow your business.",
    highlight: "Travel & Bill Payments",
    rating: 0,
    earnings: "₹38,000/month",
    duration: "15:03",
    videoSrc: "https://youtu.be/AOwmIn3ZJOI",
  },
    {
    id: 4,
    name: "Leads,Applications,Reports And More",
    location: "Leads,Applications and Report Overview",
    role: "Demo",
    avatar: "SS",
    color: "#8e44ad",
    quote: "we walk you through the powerful dashboard features including Leads, Applications, Reports, and more to help you manage your business efficiently",
    highlight: "GST Filing",
    rating: 0,
    earnings: "₹55,000/month",
    duration: "11:06",
    videoSrc: "https://youtu.be/OMeeL1zy2e8",
  }
];

